module.exports = __webpack_public_path__ + "img/16.da76bf9b.png";